import React, { useEffect, useState } from 'react';
import { useTable } from 'react-table';
import SubscriptionPopup from './SubscriptionPopup';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { FaBriefcase, FaCog, FaLock, FaUser, FaWhatsapp } from 'react-icons/fa';


const AccountDetails = () => {
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    whatsappBusinessId: '',
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  useEffect(() => {
    // Simulating getting user data from sessionStorage (or another state management system)
    const storedUser = JSON.parse(sessionStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser);
      setFormData({
        name: storedUser.name || '',
        email: storedUser.email || '',
        phone: storedUser.phone || '',
        whatsappBusinessId: storedUser.whatsappBusinessId || '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSaveChanges = async (e) => {
    e.preventDefault();
    console.log('Form data:', formData);

    try {
      const response = await fetch('https://rvapi.emedha.in/auth/api/update-profile', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: user.id,
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          whatsappBusinessId: formData.whatsappBusinessId,
          oldPassword: formData.oldPassword,
          newPassword: formData.newPassword,
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        alert(data.error || 'Error updating profile');
      } else {
        alert(data.message);  // Success message
      }
    } catch (error) {
      console.error('Error during profile update:', error);
      alert('Error during profile update. Please try again later.');
    }
  };


  const [showPopup, setShowPopup] = useState(false);
  const [selectedSection, setSelectedSection] = useState('account');
  const handleSectionChange = (section) => {
    setSelectedSection(section);
  };



  const columns = React.useMemo(
    () => [
      {
        Header: 'DISPLAY NAME',
        accessor: 'displayName',
      },
      {
        Header: 'PHONE NUMBER',
        accessor: 'phoneNumber',
      },
      {
        Header: 'PHONE NUMBER ID',
        accessor: 'phoneNumberId',
      },
      {
        Header: 'CONNECTION',
        accessor: 'connection',
      },
      {
        Header: 'STATUS',
        accessor: 'status',
        Cell: ({ value }) => (
          <span className={`px-2 py-1 rounded-md ${value === 'CONNECTED' ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-600'}`}>
            {value}
          </span>
        ),
      },
      {
        Header: 'SUBSCRIPTION',
        accessor: 'subscription',
      },
    ],
    []
  );

  const data = React.useMemo(
    () => [
      {
        displayName: 'eMedha Chatbot Services Test',
        phoneNumber: '+91 83297 69248',
        phoneNumberId: '110********',
        connection: 'Direct',
        status: 'CONNECTED',
        subscription: 'Startup (Monthly)',
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  });

  return (

    <div style={{ maxWidth: '1024px', margin: '0 auto', padding: '1rem', }}>
      <div style={{ backgroundColor: 'white', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', borderRadius: '0.375rem', padding: '1.5rem', }}>
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
          <button
            style={selectedSection === 'account' ? { backgroundColor: '#14B8A6', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 'bold', } : { backgroundColor: '#4CAF50', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', }}
            onClick={() => handleSectionChange('account')}>
            <FaUser style={{ marginRight: '8px' }} /> My Account
          </button>
          <button
            style={selectedSection === 'whatsapp' ? { backgroundColor: '#14B8A6', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 'bold', } : { backgroundColor: '#f1f1f1', color: '#4A4A4A', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', }}
            onClick={() => handleSectionChange('whatsapp')}>
            <FaWhatsapp style={{ marginRight: '8px' }} /> WhatsApp Numbers
          </button>
          <button
            style={selectedSection === 'subscriptions' ? { backgroundColor: '#14B8A6', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 'bold', } : { backgroundColor: '#f1f1f1', color: '#4A4A4A', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', }}
            onClick={() => handleSectionChange('subscriptions')}>
            <FaCog style={{ marginRight: '8px' }} /> My Subscriptions
          </button>
        </div>

        {selectedSection === 'account' && (
          <div style={{ marginBottom: '1.5rem' }}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
              <FaUser style={{ marginRight: '8px' }} /> Account Details
            </h2>
            <p style={{ color: '#4A4A4A', marginBottom: '1rem' }}>
              Details you enter on this page are for internal use like billing, support, etc. and won't be seen by your contacts.
              To edit how your WhatsApp profile looks to your contacts, you can edit that from
              <a href="#" style={{ color: '#14B8A6' }}> Settings</a> page.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gridGap: '1rem', '@media (min-width: 768px)': { gridTemplateColumns: 'repeat(2, 1fr)' } }}>
              <div style={{ marginBottom: '1.5rem' }}>
                <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                  <FaUser style={{ marginRight: '8px' }} /> Account Information
                </h2>
                <p style={{ color: '#4A4A4A', marginBottom: '1rem' }}>
                  Details you enter on this page are for internal use like billing, support, etc. and won't be seen by your contacts.
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr', gridGap: '1rem', '@media (min-width: 768px)': { gridTemplateColumns: 'repeat(2, 1fr)' } }}>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaUser style={{ marginRight: '8px' }} />NAME *
                    </label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
                  </div>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaUser style={{ marginRight: '8px' }} /> EMAIL ADDRESS *
                    </label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
                  </div>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaUser style={{ marginRight: '8px' }} /> Mobile *
                    </label>
                    <input type="email" name="phone" value={formData.phone} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
                  </div>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaUser style={{ marginRight: '8px' }} /> TIMEZONE *
                    </label>
                    <select name="timezone" value={formData.timezone} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} >
                      <option>UTC+5:30</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaUser style={{ marginRight: '8px' }} />  WhatsApp Business ID *
                    </label>
                    <input type="text" name="whatsappBusinessId" value={formData.whatsappBusinessId} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                  <FaBriefcase style={{ marginRight: '8px' }} /> Billing Details
                </h2>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr', gridGap: '1rem', '@media (min-width: 768px)': { gridTemplateColumns: 'repeat(2, 1fr)' } }}>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaBriefcase style={{ marginRight: '8px' }} /> FIRST NAME *
                    </label>
                    <input type="text" name="billingFirstName" value={formData.billingFirstName} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
                  </div>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaBriefcase style={{ marginRight: '8px' }} /> LAST NAME *
                    </label>
                    <input type="text" name="billingLastName" value={formData.billingLastName} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
                  </div>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaBriefcase style={{ marginRight: '8px' }} /> COMPANY NAME (OPTIONAL)
                    </label>
                    <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
                  </div>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaBriefcase style={{ marginRight: '8px' }} /> COUNTRY / REGION
                    </label>
                    <input type="text" name="country" value={formData.country} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
                  </div>
                </div>
              </div>

              {/* Password Section */}
              <div>
                <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                  <FaLock style={{ marginRight: '8px' }} /> Password
                </h2>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr', gridGap: '1rem', '@media (min-width: 768px)': { gridTemplateColumns: 'repeat(2, 1fr)' } }}>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaLock style={{ marginRight: '8px' }} /> CURRENT PASSWORD *
                    </label>
                    <input type="password" name="oldPassword" value={formData.oldPassword} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
                  </div>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaLock style={{ marginRight: '8px' }} /> NEW PASSWORD *
                    </label>
                    <input type="password" name="newPassword" value={formData.newPassword} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
                  </div>
                  <div>
                    <label style={{ color: '#4A4A4A' }}>
                      <FaLock style={{ marginRight: '8px' }} /> CONFIRM NEW PASSWORD *
                    </label>
                    <input type="password" name="confirmNewPassword" value={formData.confirmNewPassword} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
                  </div>
                </div>
              </div>

              <div>
                <button style={{ backgroundColor: '#4CAF50', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', }} onClick={handleSaveChanges}>
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        )}




        <>
          {selectedSection === 'whatsapp' && (
            <div>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">WhatsApp Phone Numbers</h2>
              </div>
              <p className="text-gray-600 mb-4">
                On this page you'll find all the WhatsApp phone numbers that are connected with eMedha Chatbot Services and the WhatsApp Cloud APIs.
              </p>
              <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
                <div className="d-flex flex-row justify-content-between items-center border-b pb-2 mb-4">
                  <div>
                    <h3 className="text-lg font-semibold">eMedha Chatbot Services</h3>
                    <p className="text-gray-500">
                      WABA ID: 109<span className="bg-gray-200 rounded px-2 py-1 ml-2">********</span>
                    </p>
                  </div>
                  <button className="btn btn-primary" style={{ height: 40 }}>WhatsApp Manager</button>
                </div>

                <table {...getTableProps()} className="w-full text-left">
                  <thead>
                    {headerGroups.map(headerGroup => (
                      <tr {...headerGroup.getHeaderGroupProps()} className="text-gray-600">
                        {headerGroup.headers.map(column => (
                          <th {...column.getHeaderProps()} className="py-2">
                            {column.render('Header')}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {rows.map(row => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()} className="bg-white border-b">
                          {row.cells.map(cell => {
                            return (
                              <td {...cell.getCellProps()} className="py-2">
                                {cell.render('Cell')}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>

        {selectedSection === 'subscriptions' && (
          <div>
            <div className="d-flex flex-row justify-content-between items-center border-b pb-2 mb-4">
              <div>
                <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem', }}>My Subscriptions</h2>
              </div>
              <button className="btn btn-primary" onClick={() => setShowPopup(true)}>Buy Subscription</button>
            </div>
            <table className="w-full text-left">
              <thead>
                <tr className="text-gray-600">
                  <th className="py-2">ID</th>
                  <th className="py-2">STATUS</th>
                  <th className="py-2">SUBSCRIPTION</th>
                  <th className="py-2">NEXT PAYMENT</th>
                  <th className="py-2">TOTAL</th>
                  <th className="py-2">ASSOCIATED WHATSAPP NUMBER</th>
                  <th className="py-2"></th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t">
                  <td className="py-2 text-teal-600">#235171</td>
                  <td className="py-2"><span className="bg-gray-300 text-gray-600 px-2 py-1 rounded">CANCELLED</span></td>
                  <td className="py-2">eMedha Chatbot Services - Startup (Monthly)</td>
                  <td className="py-2">-</td>
                  <td className="py-2">₹2,358.82</td>
                  <td className="py-2">-</td>
                  <td className="py-2"><button className="text-teal-600 border border-teal-600 px-4 py-1 rounded">View</button></td>
                </tr>
                <tr className="border-t">
                  <td className="py-2 text-teal-600">#232409</td>
                  <td className="py-2"><span className="bg-gray-300 text-gray-600 px-2 py-1 rounded">CANCELLED</span></td>
                  <td className="py-2">eMedha Chatbot Services - Startup (Monthly)</td>
                  <td className="py-2">-</td>
                  <td className="py-2">₹2,358.82</td>
                  <td className="py-2">-</td>
                  <td className="py-2"><button className="text-teal-600 border border-teal-600 px-4 py-1 rounded">View</button></td>
                </tr>
                <tr className="border-t">
                  <td className="py-2 text-teal-600">#158351</td>
                  <td className="py-2"><span className="bg-gray-300 text-gray-600 px-2 py-1 rounded">CANCELLED</span></td>
                  <td className="py-2">eMedha Chatbot Services - Startup (Monthly)</td>
                  <td className="py-2">-</td>
                  <td className="py-2">₹23.59</td>
                  <td className="py-2">-</td>
                  <td className="py-2"><button className="text-teal-600 border border-teal-600 px-4 py-1 rounded">View</button></td>
                </tr>
                <tr className="border-t">
                  <td className="py-2 text-teal-600">#56217</td>
                  <td className="py-2"><span className="bg-yellow-400 text-white px-2 py-1 rounded">PENDING CANCELLATION</span></td>
                  <td className="py-2">eMedha Chatbot Services - Startup (Monthly)</td>
                  <td className="py-2">-</td>
                  <td className="py-2">₹23.59</td>
                  <td className="py-2 text-teal-600">eMedha Chatbot Services Test (+91 83297 69248)</td>
                  <td className="py-2"><button className="text-teal-600 border border-teal-600 px-4 py-1 rounded">View</button></td>
                </tr>
              </tbody>
            </table>
            <Popup
              open={showPopup}
              closeOnDocumentClick
              onClose={() => setShowPopup(false)}
              modal
              nested
            >
              {(close) => (
                <div className="relative">
                  <SubscriptionPopup onClose={close} />
                </div>
              )}
            </Popup>
          </div>
        )}
      </div>
    </div>

  );
};

export default AccountDetails;


// import React, { useEffect, useState } from 'react';

// const AccountDetails = () => {
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     whatsappBusinessId: '',
//     oldPassword: '',
//     newPassword: '',
//     confirmPassword: '',
//   });

//   useEffect(() => {
//     // Simulating getting user data from sessionStorage (or another state management system)
//     const storedUser = JSON.parse(sessionStorage.getItem('user'));
//     if (storedUser) {
//       setUser(storedUser);
//       setFormData({
//         name: storedUser.name || '',
//         email: storedUser.email || '',
//         phone: storedUser.phone || '',
//         whatsappBusinessId: storedUser.whatsappBusinessId || '',
//         oldPassword: '',
//         newPassword: '',
//         confirmPassword: '',
//       });
//     }
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSaveChanges = async (e) => {
//     e.preventDefault();

//     // Check if form data is correct
//     console.log('Form data:', formData);

//     try {
//         const response = await fetch('https://rvapi.emedha.in/auth/api/update-profile', {
//             method: 'PUT',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({
//                 userId: user.id,
//                 name: formData.name,
//                 email: formData.email,
//                 phone: formData.phone,
//                 whatsappBusinessId: formData.whatsappBusinessId,
//                 oldPassword: formData.oldPassword,
//                 newPassword: formData.newPassword,
//             }),
//         });

//         const data = await response.json();
//         if (!response.ok) {
//             alert(data.error || 'Error updating profile');
//         } else {
//             alert(data.message);  // Success message
//         }
//     } catch (error) {
//         console.error('Error during profile update:', error);
//         alert('Error during profile update. Please try again later.');
//     }
// };


//   if (!user) {
//     return <div>Loading...</div>; // Loading state while user data is being fetched
//   }

//   return (
//     <div>
//       <h2>Account Details</h2>
//       <form onSubmit={handleSaveChanges}>
//         <label>
//           Name:
//           <input type="text" name="name" value={formData.name} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           Email:
//           <input type="email" name="email" value={formData.email} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           Phone:
//           <input type="text" name="phone" value={formData.phone} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           WhatsApp Business ID:
//           <input type="text" name="whatsappBusinessId" value={formData.whatsappBusinessId} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           Old Password:
//           <input type="password" name="oldPassword" value={formData.oldPassword} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           New Password:
//           <input type="password" name="newPassword" value={formData.newPassword} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           Confirm New Password:
//           <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} />
//         </label>
//         <br />
//         <button type="submit">Save Changes</button>
//       </form>
//     </div>
//   );
// };

// export default AccountDetails;
